import { AxiosInstance } from 'axios';
import { PaymentGroupService } from 'services';

export interface PaymentGroupServiceModel {
  getAll: ReturnType<typeof PaymentGroupService.getAll>;
  create: ReturnType<typeof PaymentGroupService.create>;
  update: ReturnType<typeof PaymentGroupService.update>;
  remove: ReturnType<typeof PaymentGroupService.remove>;
  toggleStatus: ReturnType<typeof PaymentGroupService.toggleStatus>;
}

export const initPaymentGroupService = (axios: AxiosInstance): PaymentGroupServiceModel => ({
  getAll: PaymentGroupService.getAll(axios),
  create: PaymentGroupService.create(axios),
  update: PaymentGroupService.update(axios),
  remove: PaymentGroupService.remove(axios),
  toggleStatus: PaymentGroupService.toggleStatus(axios),
});
